import { render } from "./ExtensionsMain.vue?vue&type=template&id=70d13ca8&scoped=true&lang=true"
import script from "./ExtensionsMain.vue?vue&type=script&lang=js"
export * from "./ExtensionsMain.vue?vue&type=script&lang=js"

import "./ExtensionsMain.vue?vue&type=style&index=0&id=70d13ca8&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-70d13ca8"

export default script